import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute } from '@angular/router'; //, Params
import { FormBuilder, Validators} from '@angular/forms'; //FormGroup, FormControl,

// PROVIDER
import {BasicProvider} from '../providers/basic/basic';
import {UserProvider} from '../providers/user/user';
//import { flattenStyles } from '@angular/platform-browser/src/dom/dom_renderer';

@Component({
  selector: 'app-add-card',
  templateUrl: './add-card.component.html',
  styleUrls: ['./add-card.component.css']
})
export class AddCardComponent implements OnInit {

  warehouseId = '';
  cardlists:any = [];
  cardForm:any;
  selectedCard = 0;
  showCardForm = false;
  cardFormError = '';
  months = [];
  years = [];
  today = new Date().toJSON().split('T')[0];


  constructor(
    public builder:FormBuilder,
    public bp: BasicProvider,
    public up: UserProvider,
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) {
    this.warehouseId = this.activatedRoute.snapshot.params['warehouseId'];
    this.getCardList();
    this.setcardform();
  }

  ngOnInit() {
  }

  showAddCardForm(){
    if (this.showCardForm) {
      this.showCardForm = false;
    } else {
      this.showCardForm = true;
    }
  }

  getCardList(){
    this.cardlists = [];
    let api = 'warehouse/get_cards';
    let searchFilter = { };
    this.bp.hitApi(api, 'GET', searchFilter,true,true)
    .subscribe(
      (success) => { 
        console.log(success);
        if ( success.type == true ) { 
          var t = {};
          if(success.data.length>0){
            for(let i=0; i<success.data.length; i++) {
              t = ( JSON.parse(success.data[i].text) );
              this.cardlists.push(t);
            }
          }
          console.log(this.cardlists);
        } else {
          this.bp.show_toast('Error',success.message);
        } 
        
      }, 
      (error) => {
        console.log(error);
      }
    );
    
  }

  public setCardImage(type) {
    let img = 'assets/imgs/visa.png';
    switch(type){
      case 'visa':{
        img = 'assets/img/visa.png';
        break;
      }
      case 'mastercard': {
        img = 'assets/img/master-card.png';
        break;
      }
      case 'maestro': {
        img = 'assets/img/visa.png';
        break;
      }
      case 'discover': {
        img = 'assets/img/visa.png';
        break;
      }
      case 'amex': {
        img = 'assets/img/visa.png';
        break;
      }
      default:{
        img = 'assets/img/visa.png';
        break;
      }
    }
    return img;
  }

  setcardform(){
    let minDate = (new Date()).getFullYear();
    let maxDate = (new Date()).getFullYear() + 50;
    
    for(let i = minDate; i<=maxDate; i++){
      this.years.push(i);
    }

    this.cardForm = this.builder.group({
      'name': ['', Validators.compose([ Validators.required ])],
      'number': ['', Validators.compose([Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(16), Validators.maxLength(16)])],
      'card_type': ['', Validators.compose([Validators.required])],
      //'exp': ['', Validators.compose([Validators.required])],
      'expire_month': ['', Validators.compose([Validators.required])],
      'expire_year': ['', Validators.compose([Validators.required])],
      'cvv': ['', Validators.compose([Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(3), Validators.maxLength(4)])],
    });

    console.log('this.up.tempWarehouseId: ',this.up.tempWarehouseId);

    this.onYearChnage(minDate);
  }

  formSubmit(){

    let validation_message = { 
      'name': {
        'required': 'Name is required field.',
      },
      'number': {
        'required': 'Card number is required field.',
        'pattern': 'Please enter valid card number.',
        'minlength': "Your card number should be 16 digit long.",
        'maxlength': "Your card number should be 16 digit long."
      },
      'card_type': {
        'required': 'Please select card type.'
      },
      'expire_month': {
        'required': 'Expiration month is required field.'
      },
      'expire_year': {
        'required': 'Expiration year is required field.'
      },
      'cvv': {
        'required': 'CVV is required field.',
        'pattern': 'Please enter valid CVV.',
        'minlength': "Your CVV should be 3 to 4 digit long.",
        'maxlength': "Your CVV should be 3 to 4 digit long."
      },
      
    };
    if(this.bp.validation(this.cardForm, validation_message)) {
      this.cardFormError = '';
      //this.paymentForm.value.expYear = this.paymentForm.value.exp.split('-')[0];
      //this.paymentForm.value.expMonth = this.paymentForm.value.exp.split('-')[1];
      this.cardForm.value.cvc = this.cardForm.value.cvv;
      var cardData = {
        type:this.cardForm.value.card_type,
        number:this.cardForm.value.number,
        expire_month:this.cardForm.value.expire_month,
        expire_year:this.cardForm.value.expire_year
      }
      
      this.bp.hitApi('warehouse/get_paypal_accesstoken', 'POST', {}, true, true)
      .subscribe(
        (success) => { 
          //console.log(success);
          if( success.type == true ){ 
            var token = success.data;
            var mode = success.mode;
            var apiUrl = 'https://api.paypal.com/v1/vault/credit-cards/';
            if(mode == 'sandbox'){
              apiUrl = 'https://api.sandbox.paypal.com/v1/vault/credit-cards/';
            }

            this.bp.paypalApi(apiUrl, 'POST', cardData, true, token).subscribe(
            (response) => {
              console.log(response);

              this.bp.hitApi('warehouse/manage_card', 'POST', {text:response,token:response.id,type:'Add'}, true, true)
              .subscribe(
                (success) => {
                  if( success.type == true ){
                    this.getCardList();
                    this.setcardform();
                    this.showCardForm = false;
                    this.bp.show_toast('Success',success.message);
                  } else{
                    this.bp.show_toast('Error',success.message);
                  } 
                },
                (error) => {
                  console.log('error 1' + error);
                });

            },
            (error)=>{
              console.log('error 1' + error);
            });

          } else {
            this.bp.show_toast('Error',success.message);
          } 
          
        }, 
        (error) => {
          console.log('error 1' + error);
        }
      );
      //this.navCtrl.push("PaymentPage");
    } else {
      this.cardFormError = this.bp.validation_error;
    }
    
  }

  onSelectionChange(card) {
    
    this.selectedCard = card;
    console.log(this.selectedCard);

  }

  onYearChnage(year){
    let cur_year = (new Date()).getFullYear();
    this.months = [];
    let minM = (new Date()).getMonth()+1;
    if( year > cur_year ){
      minM = 1;
    } else {
      let selectedMonth = this.cardForm.value.expire_month;
      //console.log('selectedMonth - ' + selectedMonth);
      if (selectedMonth < minM)
        this.cardForm.controls['expire_month'].setValue('');
    }

    let maxM = 12;
    let x:any = '';
    for(let i = minM; i <= maxM; i++){
      x = i;
      if(i <= 9){
        x = '0'+i;
      }
      this.months.push(x);
    }
  }

  payNow(data){

    if(!data){
      this.bp.show_toast('Error','Please select card for payment.');
      return false;
    }

    let api = 'warehouse/payment_confirm';
    let submitData = {
      warehouseId: this.warehouseId,
      payment_method: 'PAYPAL',
      card_id:data.id
    };
  
    this.bp.hitApi(api, 'POST', submitData, true, true)
    .subscribe(
      (success) => { 
        console.log(success);
        if( success.type == true ){ 
          this.router.navigate(['mypackage']);
          this.bp.show_toast('Success',success.message);
        } else { 
          this.bp.show_toast('Error',success.message);
        } 
        
      }, 
      (error) => {
        console.log(error);
      }
    );
  }

  deleteCard(data){
    //console.log(data);
    if(confirm("Do you want to delete this card?")) {
      this.bp.hitApi('warehouse/get_paypal_accesstoken', 'POST', {}, true, true)
      .subscribe(
        (success) => { 
          console.log(success);
          if( success.type == true ){ 
            var token = success.data;
            var mode = success.mode;
            var apiUrl = 'https://api.paypal.com/v1/vault/credit-cards/'+data.id;
            if(mode == 'sandbox'){
              apiUrl = 'https://api.sandbox.paypal.com/v1/vault/credit-cards/'+data.id;
            }
            //https://api.sandbox.paypal.com/v1/vault/credit-cards/CARD-6VP04223TV130692MLL4WGYY
            this.bp.paypalApi(apiUrl, 'DELETE', {}, true, token).subscribe(
            (response) => {
              console.log(response);

              this.bp.hitApi('warehouse/manage_card', 'POST', {text:{},token:data.id,type:'Delete'}, true, true)
              .subscribe(
                (success) => {
                  if( success.type == true ){
                    this.getCardList();
                    this.bp.show_toast('Success',success.message);
                  } else {
                    this.bp.show_toast('Error',success.message);
                  } 
                },
                (error) => {

                });

            },
            (error)=>{
              console.log(error);
            });

          } else {
            this.bp.show_toast('Error',success.message);
          } 
          
        }, 
        (error) => {
          console.log(error);
        }
      );
    }
  }

  

}



// WEBPACK FOOTER //
// ./src/app/add-card/add-card.component.ts